import { useEffect, useState } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMediaFile = async (path, signal) => {
  const response = await axiosInstance.get('/media_library/file/', {
    params: { path },
    responseType: 'blob',
    signal,
  });
  return response.data;
};

// Charge un fichier de la bibliothèque et l'expose en URL locale (blob:).
// Le téléchargement est annulé si le fichier change ou si l'aperçu se ferme,
// et l'URL est libérée pour ne pas garder le fichier en mémoire.
export const useMediaFile = (path, { enabled = true } = {}) => {
  const [state, setState] = useState({ url: null, error: null });

  useEffect(() => {
    if (!path || !enabled) return undefined;
    const controller = new AbortController();
    let url = null;
    setState({ url: null, error: null });
    fetchMediaFile(path, controller.signal)
      .then((blob) => {
        url = URL.createObjectURL(blob);
        setState({ url, error: null });
      })
      .catch((error) => {
        if (!controller.signal.aborted) setState({ url: null, error });
      });
    return () => {
      controller.abort();
      if (url) URL.revokeObjectURL(url);
    };
  }, [path, enabled]);

  const isActive = Boolean(path && enabled);
  return {
    url: isActive ? state.url : null,
    error: isActive ? state.error : null,
    isLoading: isActive && !state.url && !state.error,
  };
};

// Téléchargement direct, pour les formats que le navigateur n'affiche pas.
export const downloadMediaFile = async (path, fileName) => {
  const blob = await fetchMediaFile(path);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
